// extracted by mini-css-extract-plugin
export default {"Loader":"DataLoader_Loader__sS5bv","shadowRolling":"DataLoader_shadowRolling__uOdnG"};